import { combineReducers } from 'redux'
import facilities from './facilities/facilities.reducer'
import team from './team/team.reducer'
import households from './households/households.reducer'
import visits from './visits/visits.reducer'
import checkIns from './checkIns/checkIns.reducer'
import vets from './vets/vets.reducer'
import markets from './markets/markets.reducer'
import accounts from './accounts/accounts.reducer'
import promotions from './promotions/promotions.reducer'
import parking from './parking/parking.reducer'
const specific = combineReducers({
	facilities,
	households,
	team,
	visits,
	checkIns,
	vets,
	markets,
	accounts,
	promotions,
	parking
})

export default specific
